import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M13.8 16.801H4.2V2.4H3V18h12V2.4h-1.2v14.401zM8.8 6v9H12V6H8.8zm2 7.8H10V7.2h.8v6.6zM6 10v5h1.2v-5H6zm9.873-10H2.127C.955 0 0 .941 0 2.1c0 1.047.783 1.91 1.8 2.067V2.936a.9.9 0 0 1-.6-.836c0-.496.416-.9.927-.9h13.745c.511 0 .927.404.927.9a.9.9 0 0 1-.6.836v1.231C17.217 4.01 18 3.147 18 2.1 18 .941 17.045 0 15.873 0z" />
  </svg>
);

export default SvgComponent;
